import AtrInfo from './AtrInfo';

export default AtrInfo;
